<div class="flo-input" data-test="search-box">
  <input
    #input
    type="text"
    [placeholder]="placeholder"
    (input)="change($event)"
    [disabled]="disabled"
    floAnalytics
    name="Search"
    events="click"
  />
  <div class="right-inner-addon">
    <span *ngIf="resultText" class="results-text align-top">{{ resultText }}</span>
    <span
      #icon
      class="primary-color-text"
      data-test="search-icon"
      aria-hidden="true"
    ><flo-svg-icon icon="icon-search" width="1.25em"></flo-svg-icon></span>
  </div>
</div>
